import {
    TeamMemberType,
    InternalPermissions,
    ExternalPermissions,
} from '../containers/Admin/BuyerMarketplace/MyTeamMembers/Models/Enums';

/**
 * Mirrors the backend TeamMemberMeetingAccessRules: buyer team member permission
 * rules for meeting resources. Live meetings and clip management require
 * Communicate-level access, while viewing recorded media (past meeting recordings,
 * shared clips) is a read-only activity also open to Internal ReadOnly (Level 1)
 * members (#739).
 *
 * Both functions return `null` when the opportunity does not describe a team
 * member (owner buyers, sellers, admins, ...), so callers keep their own default
 * for the non-team-member case.
 */
interface TeamMemberPermissions {
    teamMemberType?: TeamMemberType;
    internalPermissions?: InternalPermissions;
    externalPermissions?: ExternalPermissions;
}

export const canTeamMemberUseMeetingActions = (
    opportunity: TeamMemberPermissions | null | undefined
): boolean | null => {
    if (opportunity?.teamMemberType === TeamMemberType.Internal) {
        return (
            opportunity.internalPermissions ===
                InternalPermissions.ReadOnlyAndCommunicate ||
            opportunity.internalPermissions ===
                InternalPermissions.ReadOnlyAndCommunicateAndExecute
        );
    }

    if (opportunity?.teamMemberType === TeamMemberType.External) {
        return (
            opportunity.externalPermissions ===
            ExternalPermissions.VdrAndCommunicate
        );
    }

    return null;
};

export const canTeamMemberViewRecordedMedia = (
    opportunity: TeamMemberPermissions | null | undefined
): boolean | null => {
    if (opportunity?.teamMemberType === TeamMemberType.Internal) {
        return (
            opportunity.internalPermissions === InternalPermissions.ReadOnly ||
            opportunity.internalPermissions ===
                InternalPermissions.ReadOnlyAndCommunicate ||
            opportunity.internalPermissions ===
                InternalPermissions.ReadOnlyAndCommunicateAndExecute
        );
    }

    if (opportunity?.teamMemberType === TeamMemberType.External) {
        return (
            opportunity.externalPermissions ===
            ExternalPermissions.VdrAndCommunicate
        );
    }

    return null;
};
